function useTimer() {
  let start = 0;
  let end = 0;

  const startTime = () => {
    start = Date.now();
  };

  const endTime = (label: string) => {
    if (startTime !== null) {
      end = Date.now();
      console.log(`${label}:`, `${end - start}ms`);
    } else {
      console.warn("Timer was not started. Call startTime() before endTime().");
    }
  };

  return { startTime, endTime };
}

export default useTimer;
